import React from "react";
import {
  ITrialActivationModal,
  TrialActivationComponent
} from "./trial-activation-modal.types";
import { useTrialActivationModal } from "./use-trial-activation";
import { TrialActivationMessage } from "./trial-activation-message";
import { TrialActivationStatus } from "./trial-activation-status";

const TrialActivationModal: React.FC<ITrialActivationModal> = ({
  onClose,
  primaryUser,
  subscriptionStatus
}) => {
  const primaryUserAccessToken = primaryUser ? primaryUser.access_token : "";
  const { activateTrial, activationState, showTrialActivationComponent } =
    useTrialActivationModal(primaryUserAccessToken);

  return (
    <>
      {showTrialActivationComponent ===
        TrialActivationComponent.TRIAL_ACTIVATION_MESSAGE && (
        <TrialActivationMessage
          onClose={onClose}
          activateTrial={activateTrial}
        />
      )}
      {showTrialActivationComponent ===
        TrialActivationComponent.TRIAL_ACTIVATION_STATUS &&
        activationState && (
          <TrialActivationStatus
            activationState={activationState}
            onClose={onClose}
            daysLeft={subscriptionStatus?.daysLeft}
          />
        )}
    </>
  );
};

export { TrialActivationModal };
